import React from 'react'
import './lui.css'

/**
 *  Инициализация LUI
 *
 *  @returns {JSX.Element}
 *  @constructor
 */
export default function Lui({children}) {
    return (<>{children}</>)
}
